import { state } from "./workspaceStore.js";
export const customer = (cid) => state.db.customers.find((c) => c.id === cid);
export const order = (oid) => state.db.orders.find((o) => o.id === oid);
export const payment = (pid) => state.db.payments.find((p) => p.id === pid);
